export default __webpack_public_path__ + "static/media/LocationBlack.de84d800.svg";